import {createRouter, createWebHashHistory} from 'vue-router';

const routes = [
    {
        path: '/',
        name: 'dashboard',
        component: () => import(/* webpackChunkName: "view-dashboard" */ './views/dashboard/index.vue'),
    },
    {
        path: '/account',
        name: 'account',
        component: () => import(/* webpackChunkName: "view-account" */ './views/account/index'),
    },
    {
        path: '/crud',
        name: 'crud',
        component: () => import(/* webpackChunkName: "view-crud" */ './pages/CrudDemo.vue'),
    },
    {
        path: '/timeline',
        name: 'timeline',
        component: () => import(/* webpackChunkName: "view-timeline" */ './pages/TimelineDemo.vue'),
    },
    {
        path: '/empty',
        name: 'empty',
        component: () => import(/* webpackChunkName: "view-empty" */ './components/EmptyPage.vue'),
    },
    {
        path: '/documentation',
        name: 'documentation',
        component: () => import(/* webpackChunkName: "view-documentation" */ './components/Documentation.vue'),
    },
    {
        path: '/user-groups/:id?',
        name: 'user-groups-list',
        component: () => import(/* webpackChunkName: "view-user-groups" */ './views/user_group/index'),
    },
    {
        path: '/users/:id?',
        name: 'users-list',
        component: () => import(/* webpackChunkName: "view-users" */ './views/user/index'),
    },
    {
        path: '/participants/:id?',
        name: 'participants-list',
        component: () => import(/* webpackChunkName: "view-participants" */ './views/participant/index'),
    },
    {
        path: '/participant-groups/:id?',
        name: 'participant-groups-list',
        component: () => import(/* webpackChunkName: "view-participant-groups" */ './views/participant_group/index'),
    },
    {
        path: '/organizations/:id?',
        name: 'organizations-list',
        component: () => import(/* webpackChunkName: "view-organizations" */ './views/organization/index'),
    },
    {
        path: '/alarm-points/:id?',
        name: 'alarm-points-list',
        component: () => import(/* webpackChunkName: "view-alarm-points" */ './views/alarm_point/index'),
    },
    {
        path: '/alarm-timers/:id?',
        name: 'alarm-timers',
        component: () => import(/* webpackChunkName: "view-alarm-timers" */ '@/views/alarm_timers/index'),
    },
    {
        path: '/deleted-alarm-points/:id?',
        name: 'deleted-alarm-points-list',
        component: () => import(/* webpackChunkName: "view-alarm-points" */ './views/alarm_point/index'),
    },
    {
        path: '/alarm-trigger',
        name: 'alarm-trigger',
        component: () => import(/* webpackChunkName: "view-alarm-trigger" */ './views/alarm_trigger/index'),
    },
    {
        path: '/standby-schedules',
        name: 'standby-schedules',
        component: () => import(/* webpackChunkName: "view-standby-schedules" */ './views/standby_schedules/index'),
    },
    {
        path: '/team-schedules',
        name: 'team-schedules',
        component: () => import(/* webpackChunkName: "view-team-schedules" */ './views/team_media_schedules/index'),
    },
    {
        path: '/private-schedules',
        name: 'private-schedules',
        component: () => import(/* webpackChunkName: "view-private-schedules" */ './views/private_media_schedules/index'),
    },
    {
        path: '/holidays',
        name: 'holidays',
        component: () => import(/* webpackChunkName: "view-holidays" */ './views/holidays/index'),
    },
    {
        path: '/alarm-plans/:id?',
        name: 'alarm-plans-list',
        component: () => import(/* webpackChunkName: "view-alarm-plans" */ './views/alarm_plan/index'),
    },
    {
        path: '/alarm-panels',
        name: 'alarm-panels-list',
        component: () => import(/* webpackChunkName: "view-alarm-panel" */ './views/alarm_panel/index'),
    },
    {
        path: '/alarm-table',
        name: 'alarm-table-list',
        component: () => import(/* webpackChunkName: "view-alarm-table" */ './views/alarm_table/index'),
    },
    {
        path: '/alarm-rules/:id?',
        name: 'alarm-rules',
        component: () => import(/* webpackChunkName: "view-alarm-rules" */ './views/alarm_rule/index'),
    },
    {
        path: '/alarm-templates',
        name: 'alarm-templates',
        component: () => import(/* webpackChunkName: "view-alarm-templates" */ './views/alarm_templates/index'),
    },
    {
        path: '/text-templates',
        name: 'text-templates',
        component: () => import(/* webpackChunkName: "view-text-templates" */ './views/text_templates/index'),
    },
    {
        path: '/reports/:tab',
        name: 'reports',
        component: () => import(/* webpackChunkName: "view-reports" */ './views/reports/index'),
    },
    {
        path: '/attachments',
        name: 'attachments',
        component: () => import(/* webpackChunkName: "view-attachments" */ './views/attachments/index'),
    },
    {
        path: '/alarm-apps',
        name: 'apps',
        component: () => import(/* webpackChunkName: "view-apps" */ './views/apps/index'),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "view-login" */ './views/auth/login'),
    },
    {
        path: '/test',
        name: 'test',
        component: () => import(/* webpackChunkName: "view-test" */ '@/views/test/test'),
    },
    {
        path: '/views',
        name: 'views',
        component: () => import(/* webpackChunkName: "view-system-tables" */ '@/views/system_tables/index'),
    },
    {
        path: '/import-export',
        name: 'import-export',
        component: () => import(/* webpackChunkName: "view-import-export" */ '@/views/import_export/index'),
    },
    {
        path: '/server',
        name: 'server-dashboard',
        component: () => import(/* webpackChunkName: "view-admin-server" */ '@/views/admin_panel/server/dashboard/index'),
    },
    {
        path: '/server/front/connection',
        name: 'server-front-connection',
        redirect: {name: 'server-dashboard', query: {tab: '1'}},
    },
    {
        path: '/server/back',
        name: 'server-back',
        redirect: {name: 'server-dashboard', query: {tab: '2'}},
    },
    {
        path: '/server/front/web-interface',
        name: 'server-front-web-interface',
        redirect: {name: 'server-dashboard', query: {tab: '3'}},
    },
    {
        path: '/server/settings',
        name: 'server-settings',
        component: () => import(/* webpackChunkName: "view-admin-server-settings" */ '@/views/admin_panel/server/settings/index'),
    },
    {
        path: '/modules',
        name: 'modules',
        component: () => import(/* webpackChunkName: "view-admin-modules" */ '@/views/admin_panel/modules/index'),
    },
    {
        path: '/modules/participant',
        name: 'modules-participant',
        redirect: {name: 'modules', query: {tab: '0'}},
    },
    {
        path: '/modules/signal',
        name: 'modules-signal',
        redirect: {name: 'modules', query: {tab: '1'}},
    },
    {
        path: '/alarmviewer',
        name: 'alarmviewer',
        component: () => import(/* webpackChunkName: "view-alarm-viewer" */ './views/alarm_viewer/index'),
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;
